var _internalDateLocale;
import { LangCodes } from "../../locale";
import { InternalDateDayWeek, InternalDateFirstDayWeek, InternalDateOrder, InternalDateSeparator } from "../types";
var DateCustomSet_DMY_Dot_Monday_6_7 = {
  order: InternalDateOrder.DMY,
  separator: InternalDateSeparator.Dot,
  firstDayWeek: InternalDateFirstDayWeek.Monday,
  notWorkingDays: [InternalDateDayWeek.Saturday, InternalDateDayWeek.Sunday]
};
var DateCustomSet_DMY_Slash_Sunday_6_7 = {
  order: InternalDateOrder.DMY,
  separator: InternalDateSeparator.Slash,
  firstDayWeek: InternalDateFirstDayWeek.Sunday,
  notWorkingDays: [InternalDateDayWeek.Saturday, InternalDateDayWeek.Sunday]
};
export var internalDateLocale = (_internalDateLocale = {}, _internalDateLocale[LangCodes.ru_RU] = DateCustomSet_DMY_Dot_Monday_6_7, _internalDateLocale[LangCodes.en_GB] = DateCustomSet_DMY_Slash_Sunday_6_7, _internalDateLocale);